// ============================================================
// HYVE DESIGN TOKENS
// Centralized design values for programmatic use.
// For Tailwind class-based styling, refer to frontend/CLAUDE.md.
// ============================================================

export const COLORS = {
  primary: "#7C3AED",
  primaryHover: "#6D28D9",
  primaryLight: "#EDE9FE",
  dark: "#0B1120",
  white: "#FFFFFF",
  black: "#000000",
  background: "#F9FAFB",
  textPrimary: "#0B1120",
  textSecondary: "#6B7280",
  textMuted: "#9CA3AF",
  border: "#E5E7EB",
  borderSubtle: "#F3F4F6",
  blue: "#3B82F6",
  blueLight: "#DBEAFE",
  pink: "#EC4899",
  pinkLight: "#FCE7F3",
  green: "#10B981",
  greenLight: "#D1FAE5",
  orange: "#F97316",
  orangeLight: "#FFEDD5",
};

// Background color token to hex mapping (for BookingPage customization)
export const BACKGROUND_COLOR_MAP = {
  white: COLORS.white,
  "light-gray": "#F3F4F6",
  dark: "#1F2937",
  black: COLORS.black,
  primary: COLORS.primary,
  "primary-light": COLORS.primaryLight,
  blue: COLORS.blue,
  "blue-light": COLORS.blueLight,
  green: COLORS.green,
  "green-light": COLORS.greenLight,
  pink: COLORS.pink,
  "pink-light": COLORS.pinkLight,
  orange: COLORS.orange,
  "orange-light": COLORS.orangeLight,
};

// Text color token to hex mapping
export const TEXT_COLOR_MAP = {
  black: COLORS.black,
  white: COLORS.white,
  primary: COLORS.primary,
  secondary: COLORS.textSecondary,
  muted: COLORS.textMuted,
};

// Font size token to px mapping
export const FONT_SIZE_MAP = {
  sm: 12,
  base: 14,
  lg: 16,
  xl: 18,
  "2xl": 22,
};

// Font weight token to numeric mapping
export const FONT_WEIGHT_MAP = {
  normal: 400,
  semibold: 600,
  bold: 700,
};

// Border radius token to px mapping
export const BORDER_RADIUS_MAP = {
  none: 0,
  md: 8,
  lg: 12,
  full: 9999,
};

// Box shadow token to CSS mapping
export const BOX_SHADOW_MAP = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
};

// Brand gradient values
export const BRAND = {
  gradient: "linear-gradient(135deg, #7c3aed, #a855f7, #c084fc)",
  textGradient: "linear-gradient(135deg, #8b5cf6, #c084fc, #e879f9)",
  borderGradient: "linear-gradient(135deg, #7c3aed, #a855f7)",
  hexagonClipPath: "polygon(20% 0%, 80% 0%, 100% 50%, 80% 100%, 20% 100%, 0% 50%)",
};
